import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./components/navigation";
import Header from "./components/header";
import { Gallery } from "./components/gallery";
import { Features } from "./components/features";
import { Services } from "./components/services";
import { Technology } from "./components/technology";
import { GalleryDetail } from "./components/galleryDetail";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import { Modal } from "./components/Modal";
import { MotionLayer } from "./components/MotionLayer";
import JsonData from "./data/data.json";
import "./App.css";
import "./motion.css";

const Home = ({ data, onImageClick }) => <main><Header data={data.Hero} /><Gallery data={data.Gallery} onImageClick={onImageClick} /><Features data={data.Process} /><Services data={data.Services} /><Technology data={data.Technology} capabilities={data.TechnologyCapabilities} /><GalleryDetail data={data.GalleryDetail} onImageClick={onImageClick} /><About data={data.About} /><Contact data={data.Contact} /></main>;

const App = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => { document.body.classList.add("app-ready"); return () => document.body.classList.remove("app-ready"); }, []);
  useEffect(() => { document.body.style.overflow = selectedItem ? "hidden" : ""; return () => { document.body.style.overflow = ""; }; }, [selectedItem]);
  return <Router><div className="site-shell"><MotionLayer /><Navigation /><Routes><Route path="/" element={<Home data={JsonData} onImageClick={setSelectedItem} />} /></Routes>{selectedItem && <Modal item={selectedItem} closeDetail={() => setSelectedItem(null)} />}</div></Router>;
};
export default App;
